module.exports = __webpack_public_path__ + "static/p07_borreguitoL-0d235a9e96ff2e0861e9293f6853ec0d.png";